module.exports = __webpack_public_path__ + "static/media/brand-story-wap2.05d135c2.jpg";